<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="$router.back()" />
      </template>
      経験・転職意欲管理
    </Header>
    <CustomValidationObserver
      tag="div"
      class="my-4 mx-3"
      v-slot="{ handleSubmit }"
      :initialValues="formValues"
    >
      <BusinessInfo v-model="inputValues" />
      <AppButton block class="mt-4" @click="handleSubmit(onSubmit)">
        保存する
      </AppButton>
    </CustomValidationObserver>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import BusinessInfo from "@/components/organisms/common/BusinessInfo.vue";
import { accountService } from "@/app/services/AccountService";
import { authStore } from "@/store/auth";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { BusinessInfoInputValues } from "@/types/form/BusinessInfoInputValues";

type WorkStyleType = "latest" | "preferred";

@Component({
  components: {
    AppButton,
    FeatherIcon,
    BusinessInfo,
    Header
  }
})
export default class MypageBusinessInfo extends Vue {
  inputValues: BusinessInfoInputValues = {
    experiences: [{ service: null, stint: null }],
    prComment: "",
    latestWorkStyle: [],
    preferredWorkStyle: [],
    jobChange: null
  };

  get formValues() {
    return {
      experiences: this.inputValues.experiences,
      prComment: this.inputValues.prComment,
      latestWorkStyle: this.inputValues.latestWorkStyle,
      preferredWorkStyle: this.inputValues.preferredWorkStyle,
      jobChange: this.inputValues.jobChange
    };
  }

  created() {
    this.initInput();
  }

  initInput() {
    if (!authStore.user) return;
    if (authStore.user.experiences.length > 0) {
      this.inputValues.experiences = authStore.user.experiences.map(v => ({
        stint: v.stint,
        service: v.service
      }));
    }
    this.inputValues.prComment = authStore.user.prComment;
    this.inputValues.jobChange = authStore.user.jobChange;
    this.inputValues.latestWorkStyle = this.getWorkStyle("latest") || [];
    this.inputValues.preferredWorkStyle = this.getWorkStyle("preferred") || [];
  }

  async onSubmit() {
    const styles = (style: number[], type: WorkStyleType) =>
      style.map(value => ({ type, style: value }));
    const workStyle = [
      ...styles(this.inputValues.latestWorkStyle, "latest"),
      ...styles(this.inputValues.preferredWorkStyle, "preferred")
    ];
    const experiences = this.inputValues.experiences.map(v => ({
      service: v.service!,
      stint: v.stint!
    }));

    this.$loading.show();
    try {
      await accountService.patchUser({
        prComment: this.inputValues.prComment,
        jobChange: this.inputValues.jobChange || undefined,
        experiences,
        workStyle
      });
      await this.$bvModal.msgBoxOk("経験・転職意欲を保存しました。", {
        okVariant: "success",
        centered: true
      });
      this.$router.back();
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
    }
  }

  getWorkStyle(workType: WorkStyleType) {
    if (!authStore.user) return;
    return authStore.user.workStyle
      .filter(w => w.type === workType)
      .map(w => w.style);
  }
}
</script>
